import {useCallback} from 'react'
import {Variable} from '../../common/types/variable-engine'
import {useActiveVariable} from './provider'

export type OpenVariableForm = (
  name: string,
  onSave?: (varName: string, variable: Variable) => void
) => void

export function useVariableForm() {
  const [, setActiveVariable] = useActiveVariable()
  const openForm = useCallback<OpenVariableForm>(
    (name, onSave) => {
      setActiveVariable(name, {onSave})
    },
    [setActiveVariable]
  )
  return [openForm]
}
